export class DumpsterListAssociateCollectionPointInput {
  dumpsters: number[];
  collectionPoint: number;

  constructor(dumpsters: number[], collectionPoint: number) {
    this.dumpsters = dumpsters;
    this.collectionPoint = collectionPoint;
  }
}
